import {
    updateNewCandidate,
    updateIsAddCandidateClicked,
    updateCandidates,
    updateIsEditCandidateClicked,
    updateCandidatesDataTable,
    updateIsViewCandidateClicked,
    updateNewCandidateInterview,
    updateInterview,
    updateInterviewDataTable

} from "./candidates.types";
export const updateNewCandidateAction = (params) => {
    return {
        type: updateNewCandidate,
        payload: params,
    };
};
export const updateIsAddCandidateClickedAction = (params) => {

    return {
        type: updateIsAddCandidateClicked,
        payload: params,
    };
};

export const updateCandidatesAction = (params) => {
    return {
        type: updateCandidates,
        payload: params,
    };
};
export const updateIsEditCandidateClickedAction = (params) => {
    return {
        type: updateIsEditCandidateClicked,
        payload: params,
    };
};
export const updateCandidatesDataTableAction = (params) => {
    return {
        type: updateCandidatesDataTable,
        payload: params,
    };
};
export const updateIsViewCandidateClickedAction = (params) => {
    return {
        type: updateIsViewCandidateClicked,
        payload: params,
    };
};
export const updateNewCandidateInterviewAction = (params) => {
    return {
        type: updateNewCandidateInterview,
        payload: params,
    };
};
export const updateInterviewAction = (params) => {
    return {
        type: updateInterview,
        payload: params,
    };
};
export const updateInterviewDataTableAction = (params) => {
    return {
        type: updateInterviewDataTable,
        payload: params,
    };
};